import React from 'react';

const SuperAdminPendingSheet = () => {
    return (
        <div className="view-approved-sheets-container">
            <div className="content-section" style={{fontFamily: 'Arial, sans-serif',margin: "0", padding: "0", overflowX: "hidden" }}>
                <h2 style={{ fontSize: '22px', fontWeight: '500', color: '#000000', marginTop: '20px', marginBottom: '10px' }}>
                    How can I check the status of my pending timesheet?
                </h2>
                <p className="description">
                    The "Pending Sheets" section helps you track timesheets that are awaiting approval. These timesheets are submitted by employees but have "not yet been approved"
                    by the "approval manager" or "super admin."
                    In this section, you can view, follow up, or take necessary actions on pending timesheets.
                </p>

                <h4 style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginTop: '15px', marginBottom: '5px' }}>Pending Sheets Overview</h4>
            
                    <img
                        src="https://res.cloudinary.com/danfpnuui/image/upload/v1740687060/WhatsApp_Image_2025-02-26_at_9.37.24_PM_4_it2zas.jpg"
                        alt="Pending Timesheet Screenshot"
                        style={{ width: "70%" }}
                    />
                
                <p style={{ fontSize: '16px', color: '#555', marginBottom: '10px' }}>
                    The screenshot above shows how the pending timesheets are displayed in the system. Each pending record contains key details such as:
                </p>

                <ul style={{ fontSize: '16px', color: '#555', paddingLeft: '20px' }}>
                    <li><strong>Timesheet ID (T.ID):</strong> A unique identifier assigned to each timesheet.</li>
                    <li><strong>Employee Name:</strong> The name of the employee who submitted the timesheet.</li>
                    <li><strong>Period:</strong> The specific date range for which the employee logged their working hours.</li>
                    <li><strong>Total Hours:</strong> The number of hours recorded for the selected period.</li>
                    <li><strong>Client & End Client:</strong> The company for which the employee worked and the end client.</li>
                    <li><strong>Status:</strong> Indicates whether the timesheet is "pending approval" or "rejected."</li>
                    <li><strong>Comments:</strong> Any feedback or reasons provided by the approvers regarding the timesheet status.</li>
                </ul>

                <h4 style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginTop: '15px', marginBottom: '5px' }}>Understanding Pending Timesheets</h4>
                <p style={{ fontSize: '16px', color: '#555', marginBottom: '10px' }}>
                    When a timesheet is marked as "pending," it means that the submission has been received but is "awaiting approval" from the concerned authorities.
                    If a timesheet remains pending for an extended period, employees or managers can follow up to ensure timely processing.
                </p>

                <h4 style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginTop: '15px', marginBottom: '5px' }}>What Happens if a Timesheet is Not Submitted?</h4>
                <p style={{ fontSize: '16px', color: '#555', marginBottom: '10px' }}>
                    If an "employee fails to submit a timesheet," the system will automatically send "reminders and warning emails" to notify them of the missing submission.
                    This ensures that employees complete their timesheets on time, reducing delays in payroll processing and compliance tracking.
                </p>

                <h4 style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginTop: '15px', marginBottom: '5px' }}>How to Access Pending Timesheets?</h4>
                <p style={{ fontSize: '16px', color: '#555', marginBottom: '10px' }}>
                    <li>Log in to your "Dashboard" and navigate to the "Pending Sheets" section.</li>
                    <li>Here, you will see a list of timesheets that have been submitted but are "waiting for approval."</li>
                    <li>Select a timesheet to view its details, including comments from approvers if available.</li>
                    <li>If necessary, follow up with the "approval manager or super admin" to get the timesheet reviewed.</li>
                </p>

                <h4 style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginTop: '15px', marginBottom: '5px' }}>Key Actions for Managers</h4>
                <p style={{ fontSize: '16px', color: '#555', marginBottom: '10px' }}>
                    "Follow up on pending timesheets" to avoid unnecessary payroll delays.
                    "Review the comments" for any rejections and take corrective actions if needed.
                    "Encourage employees" to submit their timesheets on time to prevent system-generated reminders.
                </p>

                <h4 style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginTop: '15px', marginBottom: '5px' }}>Tip:</h4>
                <p style={{ fontSize: '16px', color: '#555', marginBottom: '10px' }}>
                    Click on the "Pending Sheets" section to view all pending timesheets and take appropriate actions.
                </p>
            </div>
        </div>
    );
};

export default SuperAdminPendingSheet;
